<div class="modal-header">
    <h4 class="modal-title">Change <span translate="general.invoice.contract-price"></span></h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <div class="form-group">
                <label class="text-info">New <span translate="general.invoice.contract-price"></span></label>
                <input
                    legacy-css
                    appCurrency
                    type="text"
                    class="form-control"
                    [min]="0"
                    [(ngModel)]="contractPrice"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="setTotals()"
                    appSelectAllOnFocus
                    appAutoFocus />
                <div style="display: flex; padding: 8px 0px 0px 0px">
                    <div style="display: flex; flex-grow: 1">
                        <div style="flex-grow: 1; display: inline-block; text-align: right">
                            <span class="text-large">{{ taxCode }}</span>
                        </div>
                        <div
                            *ngIf="job.CalculationMethod >= 1"
                            style="display: flex; flex-flow: column nowrap; justify-content: center; align-items: center; margin-left: 6px">
                            <tax-rate-selector
                                [taxType]="0"
                                [costItemType]="0"
                                style="vertical-align: middle"
                                [selectedTaxCodes]="contractTaxRates"
                                [taxRatesParent]="job"
                                (selectedChanged)="taxRatesChanged($event)"
                                [placement]="'top'"></tax-rate-selector>
                        </div>
                    </div>
                    <div style="display: inline-block; width: 120px; text-align: right">
                        <span class="text-large"
                            ><strong>{{ tax | bxCurrency }}</strong></span
                        >
                    </div>
                </div>

                <div style="display: flex; padding: 8px 0px">
                    <div style="display: inline-block; flex-grow: 1; text-align: right"><span class="text-large">Total (Incl)</span></div>
                    <div style="display: inline-block; width: 120px; text-align: right">
                        <span class="text-large"
                            ><strong>{{ totalIncTax | bxCurrency }}</strong></span
                        >
                    </div>
                </div>
            </div>
            <div class="form-group" *ngIf="job.PaymentTotal !== 0">
                <p class="text-small text-danger">
                    New price cannot be less than {{ job.PaymentTotal | bxCurrency }} - total payment invoiced to date.
                </p>
            </div>
            <div class="form-group">
                <label class="text-info"> Markup percent you are making </label>
                <div class="input-group">
                    <input
                        legacy-css
                        type="number"
                        min="0"
                        class="form-control text-right"
                        step="any"
                        [(ngModel)]="contractMarkup"
                        required
                        tooltip="Percentage markup you've allowed for in the above contract total"
                        container="body" />
                    <span class="input-group-addon">%</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <div class="form-group">
                <label class="text-info">Reason for change:</label>
                <input legacy-css type="text" class="form-control" [(ngModel)]="reason" maxlength="255" required />
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-o btn-wide" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary btn-o btn-wide" (click)="ok()" [disabled]="!reason">Save &amp; Close</button>
</div>
